import * as types from '../type/search.type';
const defaultData = {
	courseLiveList: {
		page: {
			totalElements: 0
		},
		list: []
	},
	courseVodList: {
		page: {
			totalElements: 0
		},
		list: []
	},
	lessonLiveList: {
		page: {
			totalElements: 0
		},
		list: []
	},
	lessonVodList: {
		page: {
			totalElements: 0
		},
		list: []
	},
	keyWord: '',
	isNewSearch: false,
	liveToal: 0,
	vodToal: 0
};

const searchResult = (state = defaultData, action) => {
	let copyState = { ...state };
	switch (action.type) {
		case types.GET_COURSE_LIVE_LIST:
			copyState.courseLiveList = action.data;
			copyState.keyWord = action.keyWord;
			if (action.liveToal === 0 || action.liveToal) {
				copyState.liveToal = action.liveToal;
			}
			return copyState;
		case types.GET_COURSE_VOD_LIST:
			copyState.courseVodList = action.data;
			copyState.keyWord = action.keyWord;
			if (action.vodToal === 0 || action.vodToal) {
				copyState.vodToal = action.vodToal;
			}
			return copyState;
		case types.GET_LESSON_LIVE_LIST:
			copyState.lessonLiveList = action.data;
			copyState.keyWord = action.keyWord;
			if (action.liveToal === 0 || action.liveToal) {
				copyState.liveToal = action.liveToal;
			}
			return copyState;
		case types.GET_LESSON_VOD_LIST:
			copyState.lessonVodList = action.data;
			copyState.keyWord = action.keyWord;
			if (action.vodToal === 0 || action.vodToal) {
				copyState.vodToal = action.vodToal;
			}
			return copyState;
		case types.IS_NEW_SEARCH:
			copyState.isNewSearch = action.data;
			return copyState;
		default:
			return copyState;
	}
};
export default searchResult;



// WEBPACK FOOTER //
// ./src/redux/reducer/search.reducer.js